<template>
    <header
        class="tw-flex tw-flex-col tw-border-b tw-border-[#E4E4E7] tw-py-5 dark:tw-border-[#223457] md:tw-pt-[25px]"
    >
        <div
            class="tw-flex tw-items-center tw-justify-center sm:tw-flex-wrap sm:tw-justify-end"
        >
            <div class="tw-mr-auto tw-flex-grow">
                <slot name="top-left"></slot>
            </div>
            <!-- only use this div if top-right is used -->
            <div
                v-if="$slots['top-right']"
                class="tw-my-2 tw-flex tw-self-end tw-py-1"
            >
                <slot name="top-right"></slot>
            </div>
        </div>
        <div class="w-full">
            <slot name="bottom-full"></slot>
        </div>
    </header>
</template>
